import React, { useState } from 'react'
import Contenido from 'components/Contenido/Contenido'
import MenuVertical from 'components/MenuVertical/MenuVertical'

export default function PaginaPorDefecto(props) {
  const [collapsed] = useState(false)
  const [toggled, setToggle] = useState(false)

  const handleToggle = () => setToggle(!toggled)

  return (
    <div id='wrapper' style={{ height: '100vh' }}>
      <MenuVertical
        collapsed={collapsed}
        toggled={toggled}
        handleToggle={handleToggle}
      />
      <Contenido handleToggle={handleToggle} titulo={props.titulo}>
        {props.children}
      </Contenido>
    </div>
  )
}
